import { DiagnosisSummary } from "./DiagnosisSummary";
import { FinancialSummary } from "./FinancialSummary";
import { OverviewFilter } from "./OverviewFilter";
import { RecoveryFunnel } from "./RecoveryFunnel";

export function Overview() {
  return (
    <div className="flex flex-col gap-5">
      <OverviewFilter />
      <DiagnosisSummary />
      <RecoveryFunnel />
      <FinancialSummary />
    </div>
  );
}
